import React from 'react';
import './circle.scss';

const Counter = props => {
  return (
    <div className="textcounter" style={{ width: '100%' }}>
      <div id="counter">
        <div style={{ flexBasis: '5%' }}>
          <span id="txtcounter">{props.numChar}</span>
        </div>
        <div>
          <svg>
            <circle id="gray" cx="50%" cy="50%" r="15"></circle>
            <circle
              id="colored"
              cx="50%"
              cy="50%"
              r="15"
              style={props.ringStyle}
            ></circle>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Counter;
